export enum ProsecutionMemoCapacity {
	Prosecutor = 1,
	ComplainedAgainst = 2,
	ReportedAgainst = 3,
	MonitoredAgainst = 4,
}
